import { render, staticRenderFns } from "./seaway.vue?vue&type=template&id=d87f405a&"
import script from "./seaway.vue?vue&type=script&lang=js&"
export * from "./seaway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports